import OpenPayment from "./OpenPayment";

export default OpenPayment;
